import UserChangePasswordDialog from './UserChangePasswordDialog';

export default UserChangePasswordDialog;
